import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaginationActionsService {

  private size = new Subject<number>()

  constructor() { }

  watchSizeChange(): Observable<number> {
    return this.size.asObservable()
  }

  setSize(size: number) {
    this.size.next(size)
  }
}
